import React from "react";
import classes from "./Exams.module.scss";
import CustomImage from "../../CustomImage";

interface ExamsProps {
  countryData?: any;
}

const Exams: React.FC<ExamsProps> = ({ countryData }) => {
  const examsData = countryData?.examSection ?? [];

  return (
    <section id="exams" className={classes["exams-section"]}>
      <div className={classes["exams-container"]}>
        <h2 className={classes["exams-heading"]}>{examsData?.title ?? ""}</h2>
        <div className={classes["exams-subtext"]} dangerouslySetInnerHTML={{ __html: examsData?.description ?? "" }}></div>
        <div className={classes["exams-grid"]}>
          {examsData?.examPages?.items &&
            examsData?.examPages?.items?.length > 0 &&
            examsData?.examPages?.items?.map((exam: any) => (
              <a key={exam.id} className={classes["exam-card"]} href={`/coaching/${exam?.exam_page?.slug}`} target="_blank">
                <div className={classes["exam-card__image-wrapper"]}>
                  <CustomImage
                    src={exam?.exam_page?.logo?.url ?? "/images/default-exam-image.jpg"}
                    alt={exam?.exam_page?.name}
                    width={150}
                    height={150}
                    objectFit="contain"
                  />
                </div>
                {/* <span className={classes["exam-card__label"]}>{exam?.exam_page?.name ?? ""}</span> */}
              </a>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Exams;
